angular.module('sensores')
    .controller('sensorController', ['$rootScope', '$scope', '$location', '$route', '$routeParams', 'inspeccionesService', 'TVService', 'sensoresService', 'infraestructurasService', 'infraestructurasAdminService', 'authenticationInfo', 'authenticationService', '$sce',
        function ($rootScope, $scope, $location, $route, $routeParams, inspeccionesService, TVService, sensoresService,  infraestructurasService, infraestructurasAdminService, authenticationInfo, authenticationService, $sce) {

            $scope.damageBarChartSeccion = null;

            $scope.authentication = authenticationInfo;
            //$scope.InfraestructuraId = $routeParams.idInfraestructura;

            $scope.InspeccionId = $routeParams.id;

            $scope.pestanyamenuinspeccion = 'general';

            if ($scope.SensorId > 0) {
                sensoresService.getSensor($scope.SensorId)
                    .then(function (response) {
                        var data = response.data;
                    })
            }

            $scope.volver = function () {
                $location.path('/infraestructura/' + $rootScope.InfraestructuraId);
                $rootScope.inspeccionUrl = true;
            }

            $scope.guardar = function (mostrarAlerta) {
                //const timeElapsed = Date.now();
                //const today = new Date(timeElapsed);

                //var inspeccionSQL = new Object();
                //inspeccionSQL.Id = $scope.InspeccionId;
                //inspeccionSQL.Descripcion = $scope.inspeccion.Descripcion;
                //inspeccionSQL.IndiceTubo = $scope.inspeccion.IndiceTubo;
                //inspeccionSQL.IdentificadorTubo = $scope.inspeccion.IdentificadorTubo;
                //inspeccionSQL.FechaInicio = $scope.inspeccion.FechaInicio;
                //inspeccionSQL.FechaFin = $scope.inspeccion.FechaFin ? $scope.inspeccion.FechaFin : ''; // Verificación específica
                //inspeccionSQL.NumTramos = $scope.inspeccion.NumTramos;
                //inspeccionSQL.LongTramo = $scope.inspeccion.LongTramo;
                //inspeccionSQL.InspectorId = $scope.inspeccion.InspectorId;
                //inspeccionSQL.PropietarioId = $scope.inspeccion.PropietarioId;
                //inspeccionSQL.TunelId = $scope.TunelId;
            };

            $scope.logout = function () {
                return authenticationService.logout();
            }

            $scope.verCategorias = function () {
                $rootScope.inspeccionUrl = false;
                $rootScope.parteUrl = false;
                $location.path('/categorias');
            };
            
        }
    ]);